<template lang="pug">
section.visualizar-territorio
    .dados
        header
            h1
                i.el-icon-arrow-left.back(@click='goBack()')
                | {{ $t('mensagens.territorio.titulo') }}
        .mb2(v-if='territorio')
            p
                b {{ $t('mensagens.territorio.labels.nome') }}:
                |
                | {{ territorio.nome }}
            p
                b {{ areaLabel }}:
                |
                | {{ formatNumber(areaValue) }}
            p
                b {{ $t('mensagens.territorio.labels.localidade') }}:
                |
                | {{ territorio.localidade }}
            p(v-if='territorio.certificacoes.length')
                b {{ $t('mensagens.territorio.labels.certificacoes') }}:
                |
                | {{ nomesCertificacoes }}
            p
                b {{ $t('mensagens.territorio.labels.dataCadastro') }}:
                |
                | {{ territorio.dataCadastroFormatada }}
            p(v-if='territorio.dataAtualizacao')
                b {{ $t('mensagens.territorio.labels.dataDaUltimaAtualizacao') }}:
                |
                | {{ territorio.dataAtualizacaoFormatada }}
            p(v-if='ff1183CodigoLyraTerritorio')
                b {{ $t('mensagens.territorio.labels.codigoLyra') }}:
                |
                | {{ territorio.codigoLyra }}

        hr

        el-collapse(
            v-model='collapseDadosTerritorioAtivo',
            @change='handleChangeCollapse',
            accordion
        )
            el-collapse-item(v-if='!ambienteNorthAmerica', name='REPRESENTANTE')
                template(slot='title')
                    .titulo-collapse
                        i.flow.flow-user-second
                        |
                        | {{ $t('mensagens.territorio.representante.titulo') }}
                .container-dados-collapse
                    div(v-if='representantes.length')
                        .representante.mb2(
                            v-for='representante in representantes'
                        )
                            p
                                b {{ $t('mensagens.territorio.representante.nome') }}:
                                |
                                | {{ representante.nomeRazaoSocial }}

                            p
                                b {{ $t('mensagens.territorio.representante.documento') }}:
                                |
                                | {{ getFormattedRepresentanteDocument(representante) }}

                            p(v-if='representante.email')
                                b {{ $t('mensagens.territorio.representante.email') }}:
                                |
                                | {{ representante.email }}
                    .container-nenhum-resultado-collapse(v-else)
                        el-empty(:description='$t("mensagens.comuns.erros.nenhumResultadoEncontrado")')

            el-collapse-item(v-if='!ambienteNorthAmerica', name='CAR')
                template(slot='title')
                    .titulo-collapse
                        i.flow.flow-shape
                        |
                        | {{ $t('mensagens.territorio.car.titulo') }}
                .container-dados-collapse
                    div(v-if='cars.length > 0')
                        el-table#tabelas-collapse(
                            :data='cars',
                            style='width: 100%'
                        )
                            el-table-column
                                template(slot='header', slot-scope='scope')
                                    span {{ $t('mensagens.territorio.car.numeroCar') }}
                                template(slot-scope='scope')
                                    span {{ scope.row.codigo }}
                            el-table-column(width='90')
                                template(slot='header', slot-scope='scope')
                                    span {{ $t('mensagens.territorio.car.situacao') }}
                                template(slot-scope='scope')
                                    span {{ validaSituacao(scope.row.status) }}
                    .container-nenhum-resultado-collapse(v-else)
                        el-empty(:description='$t("mensagens.comuns.erros.nenhumResultadoEncontrado")')

            el-collapse-item(v-if='!ambienteNorthAmerica', name='COMERCIALIZACAO')
                template(slot='title')
                    .titulo-collapse
                        i.mdi.mdi-briefcase-arrow-up-down-outline
                        |
                        | {{ $t('mensagens.territorio.comercializacao.tituloPlural') }}
                .container-dados-collapse
                    div(v-if='comercializacoes.length > 0')
                        el-table#tabelas-collapse(
                            :data='comercializacoes',
                            style='width: 100%'
                        )
                            el-table-column(type='expand')
                                template(slot-scope='scope')
                                    el-divider.custom-divider
                                    el-descriptions.descricao-item-tabela(
                                        :size='"mini"'
                                    )
                                        el-descriptions-item(:label='$t("mensagens.territorio.comercializacao.numeroContrato")')
                                            .item-list-row
                                                span {{ scope.row.numeroContrato }}
                                    el-descriptions.descricao-item-tabela(
                                        :size='"mini"'
                                    )
                                        el-descriptions-item(:label='$t("mensagens.territorio.comercializacao.fornecedor")')
                                            .item-list-row
                                                span {{ scope.row.fornecedor }}

                            el-table-column
                                template(slot='header', slot-scope='scope')
                                    span {{ $t('mensagens.territorio.comercializacao.produto') }}
                                template(slot-scope='scope')
                                    span {{ scope.row.produto.nome }}
                            el-table-column
                                template(slot='header', slot-scope='scope')
                                    .text-align-right
                                        span {{ $t('mensagens.territorio.comercializacao.quantidade') }}
                                template(slot-scope='scope')
                                    .text-align-right
                                        span {{ scope.row.quantidade }}
                            el-table-column
                                template(slot='header', slot-scope='scope')
                                    .text-align-right
                                        span {{ $t('mensagens.territorio.comercializacao.unDeMedida') }}
                                template(slot-scope='scope')
                                    .text-align-right
                                        span {{ scope.row.unidadeMedida.nome }} ({{ scope.row.unidadeMedida.simbolo }})
                    .container-nenhum-resultado-collapse(v-else)
                        el-empty(:description='$t("mensagens.comuns.erros.nenhumResultadoEncontrado")')

            el-collapse-item(
                v-if='usuarioLogado.historicoMonitoramentoAccess && !ambienteNorthAmerica',
                name='HISTORICO_AGRICOLA'
            )
                template(slot='title')
                    .titulo-collapse
                        i.mdi.mdi-history
                        |
                        | {{ $t('mensagens.territorio.historicoAgricola') }}

                .container-dados-collapse
                    div(v-if='historicos.length')
                        el-table#tabelas-collapse.espacamento-historico(
                            @cell-mouse-enter='tabelaHistoricoAgricolaHover',
                            @cell-mouse-leave='tabelaHistoricoAgricolaLeaver',
                            :data='historicos',
                            style='width: 100%'
                        )
                            el-table-column(:label='$t("mensagens.territorio.ciclo")')
                                template(slot-scope='scope')
                                    span {{ scope.row.codigoAnoSafra }}
                            el-table-column(
                                prop='codigoCultura',
                                :label='$t("mensagens.territorio.cultura")'
                            )
                            el-table-column(width='110')
                                template(slot='header', slot-scope='scope')
                                    .text-align-right
                                        span {{ $t('mensagens.territorio.produtividade') }} (sc/ha | @/ha)
                                template(slot-scope='scope')
                                    .text-align-right
                                        span {{ scope.row.produtividadeKgHa }}
                            el-table-column(width='110')
                                template(slot='header', slot-scope='scope')
                                    .text-align-right
                                        span {{ $t('mensagens.territorio.areaPlantada') }} (ha)
                                template(slot-scope='scope')
                                    .text-align-right
                                        span {{ scope.row.areaHa }}
                    .container-nenhum-resultado-collapse(v-else)
                        el-empty(:description='$t("mensagens.comuns.erros.nenhumResultadoEncontrado")')

            el-collapse-item(
                v-if='territorio && territorio.diagnosticoSocioambiental !== null',
                name='DIAGNOSTICO',
                v-model="childCollapse",
            )
                template(slot='title')
                    .titulo-collapse
                        i.mdi.mdi-clipboard-pulse-outline
                        |
                        | {{ $t('mensagens.territorio.diagnosticoSocioambiental') }}

                .container-dados-collapse
                    div(v-if='diagnosticoSocioambientalTerritorio')
                    el-collapse(
                        v-model="childCollapse",
                        accordion,
                        @change='fecharCollapseFilhos',
                    )
                        el-collapse-item(
                            name='DIAGNOSTICO_SOCIOAMBIENTAL',
                        )
                            template(slot='title')
                                .titulo-collapse
                                    i.mdi.mdi-clipboard-pulse-outline
                                    |
                                    | {{ $t('mensagens.territorio.titulo') }}
                            .container-dados-collapse
                                DiagnosticoSocioambiental(
                                    v-if='refMapa',
                                    :dadosConsulta='diagnosticoSocioambientalTerritorio',
                                    @index-aberto='mostrarRestricaoTerritorio',
                                    :fecharCollapses='true',
                                    :mapaLeaflet='refMapa',
                                    :habilitar-zoom-restricao='true'
                                )

                            div(v-if='diagnosticoRepresentante && !ambienteNorthAmerica')
                                div(v-for='representantes in diagnosticoRepresentante')
                                    el-collapse(
                                        accordion,
                                        @change='fecharCollapseFilhos',
                                    )
                                        el-collapse-item(
                                            name='DIAGNOSTICO_SOCIOAMBIENTAL_REPRESENTATES',
                                            before-enter
                                        )
                                            template(slot='title')
                                                .subtitulo-collapse
                                                    i.flow.flow-user-second.mr-2
                                                    |
                                                    | {{ $t('mensagens.territorio.representante.titulo') }}
                                            .container-dados-collapse
                                                el-collapse(
                                                    accordion,
                                                    @change='fecharCollapseFilhos',
                                                )
                                                    el-collapse-item(
                                                        v-for='(representante, index) in representantes',
                                                        :name='index'
                                                    )

                                                        template(slot='title')
                                                            .subtitulo-collapse
                                                                i.flow.flow-user-second.mr-2
                                                                |
                                                                | {{ representante.nomeRepresentante }} - {{ representante.documento }}
                                                        .container-dados-collapse
                                                            DiagnosticoSocioambiental(
                                                                v-if='refMapa',
                                                                :dadosConsulta='representante',
                                                                :cpfCnpj='representante.documento',
                                                                @index-aberto='atualizarRestricaoMapaCpf',
                                                                :fecharCollapses='true',
                                                                :mapaLeaflet='refMapa',
                                                                :habilitar-zoom-restricao='true'
                                                            )
                            div(v-if='diagnosticoCar && !ambienteNorthAmerica')
                                div(v-for='cars in diagnosticoCar')
                                    el-collapse(
                                        accordion,
                                        @change='fecharCollapseFilhos',
                                    )
                                        el-collapse-item(
                                            name='DIAGNOSTICO_SOCIOAMBIENTAL_CARS'
                                        )
                                            template(slot='title')
                                                .subtitulo-collapse
                                                    i.flow.flow-shape.mr-2
                                                    |
                                                    | {{ $t('mensagens.territorio.car.titulo') }}
                                            .container-dados-collapse
                                                el-collapse(
                                                    accordion,
                                                    @change='fecharCollapseFilhos',
                                                )
                                                    el-collapse-item(
                                                        v-for='(car, index) in cars',
                                                        :name='index',
                                                    )

                                                        template(slot='title')
                                                            .subtitulo-collapse
                                                                i.flow.flow-shape.mr-2
                                                                |
                                                                | {{ car.imovel.codigo }}
                                                        .container-dados-collapse
                                                        DiagnosticoSocioambiental.mb-3.mt-3(
                                                            v-if='refMapa',
                                                            :mapaLeaflet='refMapa',
                                                            style='padding: 0; display: grid',
                                                            :indexCollapse='index',
                                                            :dadosConsulta='car',
                                                            :habilitar-opacidade='true',
                                                            :habilitar-sinal-aviso='true',
                                                            v-bind:car='getCar(car.imovel.codigo)',
                                                            @index-aberto='atualizarRestricaoMapaCars',
                                                            :habilitar-zoom-restricao='true'
                                                        )

                            .container-nenhum-resultado-collapse(v-else-if='!ambienteNorthAmerica')
                                el-empty(:description='$t("mensagens.comuns.erros.nenhumResultadoEncontrado")')

    mapa.mapa(
        :mapLayersConfigs='layersMaps',
        :mapConfig='mapConfig',
        :height='"100%"',
        :idMapa='"mapaTerritorio"',
        ref='mapa',
        :atualizarMapa='true',
        :menuMaior='true'
    )
</template>

<script>
import territorioService from '@/services/TerritorioService';
import StatusCar from '@/constants/StatusCar';
import Mapa from '@/components/MapaLeaflet.vue';
import formatters from '@/utils/formatters';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';
import { mapState } from 'vuex';
import HistoricoService from '@/services/HistoricoService';
import DiagnosticoSocioambientalService from '@/services/DiagnosticoSocioambientalService';
import DiagnosticoSocioambiental from '@/components/diagnosticoSocioambiental/index.vue';
import L from 'leaflet';
import centroidFromGeoJSON from '@/utils/centroidFromGeoJSON';
import EventBus from '@/utils/eventBus';
import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';
import { formatFlag } from '@/utils/featureFlags/featureFlag';
import { FeatureFlagConst } from '@/constants/FeatureFlag';

export default {
    name: 'VisualizarTerritorio',
    components: {
        Mapa,
        DiagnosticoSocioambiental
    },
    data() {
        return {
            idTerritorio: this.$route.params.idTerritorio,
            territorio: null,
            representantes: [],
            cars: [],
            comercializacoes: [],
            layersMaps: [],
            mapConfig: {
                controls: {
                    zoomControl: true,
                    camadasControl: true,
                    fullscreen: true,
                    buscarCarControl: true
                },
                inspecionar: true
            },
            historicos: [],
            collapseDadosTerritorioAtivo: '',
            tabelaHistoricoRowSelecionada: null,
            nomesCertificacoes: '',
            diagnosticoSocioambientalTerritorio: null,
            diagnosticoRepresentante: null,
            diagnosticoCar: null,
            refMapa: null,
            childCollapse: [],
            ff1183CodigoLyraTerritorio: this.$unleash.isEnabled(formatFlag(FeatureFlagConst.FF1183_CODIGO_LYRA_TERRITORIO))
        };
    },
    computed: {
        ...mapState(['usuarioLogado']),
        ambienteNorthAmerica() {
            return (
                this.usuarioLogado &&
                this.usuarioLogado.paisGrupo === AmbientesEmpresas.NORTE_AMERICA
            );
        },
        areaLabel() {
            if (this.ambienteNorthAmerica) {
                return this.$t('mensagens.territorio.labels.areaAcre');
            }
            return this.$t('mensagens.territorio.labels.areaHa');
        },
        areaValue() {
            if (this.ambienteNorthAmerica) {
                return this.territorio.areaAc;
            }
            return this.territorio.areaHa;
        }
    },
    async mounted() {
        await this.fetchTerritorio();
        this.refMapa = this.$refs.mapa;
    },

    created() {
        if (this.usuarioLogado.paisGrupo !== AmbientesEmpresas.BRASIL) {
            this.configuracoesMapa.controls.buscarCarControl = false;
        }
    },
    methods: {
        async fetchTerritorio() {
            const { data } = await territorioService.findById(
                this.idTerritorio
            );
            this.territorio = data;

            this.cars = this.territorio.cars;
            this.representantes = this.territorio.representantes;
            if (this.territorio.comercializacoes != null) {
                this.comercializacoes = this.territorio.comercializacoes;
                this.comercializacoes.forEach(c => {
                    c.quantidade = formatters.formatNumber(c.quantidade);
                    c.info =
                        ' - ' +
                        c.quantidade +
                        ' (' +
                        c.unidadeMedida.simbolo +
                        ')';
                });
            }
            if (this.territorio.certificacoes != null) {
                this.territorio.certificacoes.forEach(c => {
                    if (this.nomesCertificacoes.length > 0) {
                        this.nomesCertificacoes += ', ';
                    }
                    this.nomesCertificacoes += c.nome;
                });
            }
            this.configureLayersMapa();
        },
        configureLayersMapa() {
            this.layersMaps = [];

            let layerTerritorio = {
                style: getEstiloGeometria('area'),
                name: this.$t('mensagens.territorio.titulo'),
                geoJson: this.territorio.geometria
            };

            this.layersMaps.push(layerTerritorio);
        },
        formatUSPhone(phone) {
            return phone
                .replace(/^\+1 /g, '')
                .replace(/^1/g, '')
                .replace(/\D/g, '')
                .replace(/^(\d)/, '+1 ($1')
                .replace(/^(\+1 \(\d{3})/, '$1) ')
                .replace(/( \d{3})(\d)/, '$1-$2')
                .replace(/( \d{3}-\d{4})(.*)$/, '$1');
        },
        numeralStringFormatTocpfCnpj(valor, tipoDocumento) {
            return formatters.numeralStringFormatToDocumento(valor, tipoDocumento);
        },
        formatNumber(number) {
            return number
                ? Number(number).toLocaleString('pt-br', {
                      minimumFractionDigits: 4
                  })
                : '-';
        },
        goBack() {
            this.$router.go(-1);
        },
        async handleChangeCollapse() {
            switch (this.collapseDadosTerritorioAtivo) {
                case 'HISTORICO_AGRICOLA':
                    await this.buscarHistoricoAgricola();
                    break;

                case 'DIAGNOSTICO':
                    this.childCollapse = [];
                    EventBus.$emit('fecharCollapses');
                    await this.buscarDiagnosticoSocioambiental();
                    break;
                default:
                    break;
            }
        },

        fecharCollapseFilhos() {
            EventBus.$emit('fecharCollapses');
        },

        async buscarHistoricoAgricola() {
            const { data } = await HistoricoService.buscarAgricola(
                JSON.stringify(this.territorio.geometria)
            );
            this.historicos = data;
        },

        async buscarDiagnosticoSocioambiental() {
            const { data } = await DiagnosticoSocioambientalService.buscarPorId(
                JSON.stringify(this.territorio.diagnosticoSocioambiental.id)
            );
            this.diagnosticoSocioambientalTerritorio = {
                diagnostico: JSON.parse(data.resultado),
                protocoloDescricao: data.protocoloDescricao
            };

            if (this.ambienteNorthAmerica && Array.isArray(this.diagnosticoSocioambientalTerritorio.diagnostico)) {
                for (const diagnostico of this.diagnosticoSocioambientalTerritorio.diagnostico) {
                   diagnostico.resultados = diagnostico.resultados.filter(
                       resultado => Number(resultado?.properties?.areaHa) > 1
                   );
                }
            }

            this.diagnosticoRepresentante = {
                diagnostico: JSON.parse(data.resultadoRepresentante)
            };

            this.diagnosticoCar = {
                diagnostico: JSON.parse(data.resultadoCar)
            };
            
            this.$notify.info({
                message: this.$t('mensagens.territorio.diagnosticoRealizadoNoMomentoDoCadastro')
            });
        },

        fecharTodos() {

        },

        mostrarRestricaoTerritorio(_, indexCollapse, indexCamada) {
            this.layersMaps = [];

            this.layersMaps.push({
                style: getEstiloGeometria('area'),
                name: this.$t('mensagens.territorio.titulo'),
                geoJson: this.territorio.geometria
            });

            if (indexCamada) {
                this.diagnosticoSocioambientalTerritorio.diagnostico[
                    indexCamada
                ].resultados.forEach((restricao, index) => {
                    const geometria = restricao.geometria || restricao.geometry;

                    if (geometria) {
                        const pin = L.icon({
                            iconUrl: 'https://lyra-v1.s3.amazonaws.com/Pin+da+restricao.png',
                            iconSize: [18, 18]
                        });

                        this.layersMaps.push({
                            name: `CentroidDiagnostico_${index}_${indexCollapse}`,
                            icon: pin,
                            geoJson: centroidFromGeoJSON.get(geometria)
                        });
                    }

                    this.layersMaps.push({
                        style: getEstiloGeometria('restricao'),
                        name: `restricaoTerritorio_${indexCamada}_${index}`,
                        geoJson: restricao.geometry
                    });
                });
            }
        },

        atualizarRestricaoMapaCpf(restricao, indexCollapse, indexCollapseRow) {
            this.areasRestricao = [];

            const indexTagRemove =
                this.indexUltimaRestricaoAbertaRepresentante != null
                    ? this.indexUltimaRestricaoAbertaRepresentante
                    : indexCollapseRow;
            const tagRestricaoRemove = `${indexCollapse}-representante-${indexTagRemove}`;
            this.layersMaps = this.layersMaps.filter(
                l => l.tagRestricao !== tagRestricaoRemove
            );

            if (indexCollapseRow !== '' && this.diagnosticoRepresentante[indexCollapse]) {
                this.indexUltimaRestricaoAbertaRepresentante = indexCollapseRow;

                if (
                    this.diagnosticoRepresentante[indexCollapse].diagnostico[
                        indexCollapseRow
                    ]
                ) {
                    this.areasRestricao = {
                        areas: this.diagnosticoRepresentante[indexCollapse].diagnostico[
                            indexCollapseRow
                        ].resultados.map(
                            resultado =>
                                resultado.geometria || resultado.geometry
                        ),
                        camada: this.diagnosticoRepresentante[indexCollapse].diagnostico[
                            indexCollapseRow
                        ].camada
                    };
                }

                const tagRestricaoAdd = `${indexCollapse}-representante-${indexCollapseRow}`;
                const group = `grupo-restricoes-${indexCollapse}-${indexCollapseRow}`;
                this.mostrarAreasDiagnosticoNoMapa(
                    tagRestricaoAdd,
                    group,
                    restricao
                );
            }
        },

        atualizarRestricaoMapaCars(restricao, indexCollapse, indexCollapseRow) {
            this.areasRestricao = [];
            
            const indexTagRemove =
                this.indexUltimaRestricaoAbertaCar !== null
                    ? this.indexUltimaRestricaoAbertaCar
                    : indexCollapseRow;

            const tagRestricaoRemove = `${indexCollapse}-car-${indexTagRemove}`;
            this.layersMaps = this.layersMaps.filter(
                l => l.tagRestricao !== tagRestricaoRemove
            );
            if (indexCollapseRow !== '') {
                this.indexUltimaRestricaoAbertaCar = indexCollapseRow;
                if (
                    this.diagnosticoCar.diagnostico[indexCollapse].diagnosticos[indexCollapseRow]
                ) {
                    this.areasRestricao = {
                        areas: this.diagnosticoCar.diagnostico[indexCollapse].diagnosticos[
                            indexCollapseRow
                        ].resultados.map(
                            resultado =>
                                resultado.geometria || resultado.geometry
                        ),
                        camada: this.diagnosticoCar.diagnostico[indexCollapse].diagnosticos[
                            indexCollapseRow
                        ].camada
                    };
                }

                const tagRestricaoAdd = `${indexCollapse}-car-${indexCollapseRow}`;
                const group = `grupo-restricoes-${indexCollapse}-${indexCollapseRow}`;
                this.mostrarAreasDiagnosticoNoMapa(
                    tagRestricaoAdd,
                    group,
                    restricao
                );
            }
        },

        mostrarAreasDiagnosticoNoMapa(tagRestricao, group, restricao) {
            const opacidade =
                this.areasRestricao.camada.opacidade >= 0.0
                    ? this.areasRestricao.camada.opacidade / 200
                    : 0.5;

            this.areasRestricao.areas.forEach((area, index) => {
                this.layersMaps.push({
                    style: {
                        color: 'red',
                        weight: 1,
                        fill: true,
                        opacity: opacidade,
                        fillOpacity: opacidade
                    },
                    name: `AreaDiagnostico ${index}`,
                    tagRestricao,
                    group,
                    geoJson: area
                });

                const pin = L.icon({
                    iconUrl: 'https://lyra-v1.s3.amazonaws.com/Pin+da+restricao.png',
                    iconSize: [18, 18]
                });

                this.layersMaps.push({
                    name: `CentroidDiagnostico ${index}`,
                    icon: pin,
                    tagRestricao,
                    group,
                    geoJson: centroidFromGeoJSON.get(area)
                });
            });
        },

        getCar(car) {
            if (car.toUpperCase().startsWith('PA')) {
                return car;
            }
        },

        tabelaHistoricoAgricolaHover(row) {
            let layerTerritorio = {
                style: getEstiloGeometria('historicoAgricola'),
                name: 'Histórico',
                geoJson: row.geometria
            };

            this.layersMaps = [...this.layersMaps, layerTerritorio];
        },
        tabelaHistoricoAgricolaLeaver() {
            this.layersMaps = this.layersMaps.filter(
                l => l.name !== 'Histórico'
            );
        },

        validaSituacao(situacao) {
            return StatusCar[situacao];
        },
        getFormattedRepresentanteDocument(representante) {
            if (representante.tipoDocumento?.codigo === 'PHONE') {
                return this.ambienteNorthAmerica
                     ? this.formatUSPhone(representante.cpfCnpj)
                     : representante.cpfCnpj;
            }
            return this.numeralStringFormatTocpfCnpj(representante.cpfCnpj, representante.tipoDocumento.nome);
        }
    }
};
</script>

<style lang="scss">
.visualizar-territorio {
    padding: 20px;
    height: 100%;
    width: 100%;
    display: flex;
}

header {
    grid-area: header;
    margin-bottom: 30px;

    h1 {
        line-height: 1;
    }
}

.espacamento-historico {
    height: auto;
}

.dados {
    width: 600px;
    background-color: var(--white);

    padding: 16px;
    border-radius: 5px 0 0 5px;

    overflow: auto;

    .mb1 {
        margin-bottom: 15px;
        margin-top: 20px;
    }

    .mb2 {
        margin-bottom: 32px;
    }

    p {
        line-height: 1.5;
    }

    h2 {
        margin-left: 15px;
    }

    h3 {
        margin-left: 30px;
    }

    .el-collapse-item__content {
        padding-bottom: 0 !important;
    }
}

.mapa {
    grid-area: mapa;
    width: 100%;
    border-radius: 0 5px 5px 0;
    overflow: hidden;
}

.back {
    cursor: pointer;
    line-height: 2;
}

.titulo-collapse {
    font-size: 18px;
    font-weight: normal;
}

.subtitulo-collapse {
    font-size: 16px;
    font-weight: normal;
}

.container-dados-collapse {
    margin-left: 12px;
}

.container-nenhum-resultado-collapse {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    i {
        color: #a7a7a7;
        font-size: 30px;
    }
}

#tabelas-collapse {
    font-size: 14px;
    color: var(--primary-font-color);

    tr:nth-child(odd) {
        background-color: var(--selected-background-color);
    }
}

#tabelas-collapse > div.el-table__header-wrapper > table > thead > tr > th {
    font-weight: 500 !important;
    font-size: 14px !important;
    color: var(--primary-font-color) !important;
}

#tabelas-collapse
    > div.el-table__body-wrapper.is-scrolling-none
    > table
    > tbody
    > tr
    > td {
    border: none !important;
}

#tabelas-collapse
    > div.el-table__body-wrapper.is-scrolling-none
    > table
    > tbody
    > tr
    > td
    > .cell
    > span {
    word-break: break-word;
}

#tabelas-collapse > div.el-table__header-wrapper > table > thead > tr > th {
    border: none !important;
}

.text-align-right {
    text-align: right;
}

.item-list-row {
    display: grid;
    grid-template-columns: auto auto auto;
    width: 100%;
    column-gap: 10px;
}

.custom-divider {
    margin-bottom: 1px !important;
    margin-top: -12px !important;
}
</style>
